module.exports = new Promise((resolve, reject) => {
          if (!!window.apw.APW_ROUTES) {
            reject("APW_ROUTES is present, you may ignore this warning")
            return
          }
          const script = document.createElement('script')
          const defaultUrl = window.location.origin + '/appms/bundle.js'
          script.src = window.apw.APW_BUNDLE_APP_URL || defaultUrl
          script.onload = () => {
            const scope = window?.apw?.APW_BUNDLE_APP_SCOPE ? window.apw.APW_BUNDLE_APP_SCOPE : "apwApp"
            resolve(window[scope])
          }
          script.onerror = () => {
            reject()
          }
          document.head.appendChild(script);
        })
        ;